import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { BankAccount, BankStatementMonthlySummary, NewBankAccount } from 'app/models/dto/bank-account.model';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export interface BankAccountApiPayload {
  accounts?: BankAccount[];
  bankValues?: BorrowerValue[];
  deleted: string;
  mostRecentSummaryOutdated: boolean;
  ocrolusStatus: string;
  hasOcrolusErrors: boolean;
}

interface ClonedAccountDetails {
  account: BankAccount;
  summaries: any[];
  transactions: any[];
}

@Injectable({
  providedIn: 'root'
})
export class BankAccountService {

  constructor(private http: ApiHttpClient) { }

  get(borrowerId: number): Observable<BankAccountApiPayload> {
    return this.http.get<BankAccountApiPayload>(`${environment.API_URL}/bank-statement-account/${borrowerId}`);
  }

  post(newBankAccount: NewBankAccount): Observable<BankAccount> {
    return this.http.post<BankAccount>(`${environment.API_URL}/bank-statement-account/${newBankAccount.borrowerId}`, newBankAccount);
  }

  createBankStatementMonthlySummary(summary: BankStatementMonthlySummary, borrowerId: number): Observable<BankStatementMonthlySummary> {
    return this.http.post<BankStatementMonthlySummary>(`${environment.API_URL}/bank-statement-monthly-summaries/${borrowerId}`, summary);
  }

  put(bankAccount: BankAccount, borrowerId: number): Observable<BankAccount> {
    const modifiedBankAccount = {id: bankAccount.id, accountNumber: bankAccount.accountNumber, accountType: bankAccount.accountType};
    return this.http.put<BankAccount>(`${environment.API_URL}/bank-statement-account/${borrowerId}`, modifiedBankAccount);
  }

  clone(bankAccountId: number, borrowerId: number): Observable<ClonedAccountDetails> {
    return this.http.put<ClonedAccountDetails>(`${environment.API_URL}/bank-statement-account/clone/${borrowerId}`, {id: bankAccountId});
  }

  softDelete(bankAccountId: number, borrowerId: number) {
    const accountToSoftDelete = { id: bankAccountId };
    return this.http.put<BankAccount>(`${environment.API_URL}/bank-statement-account/remove/${borrowerId}`, accountToSoftDelete);
  }

  updateSummaries(summaries: BankStatementMonthlySummary[], borrowerId: number): Observable<BorrowerValue[]> {
    return this.http.put<BorrowerValue[]>(`${environment.API_URL}/bank-statement-monthly-summaries/${borrowerId}`, summaries);
  }

  acknowledgeOcrolusErrors(borrowerId: number) {
    return this.http.post<void>(`${environment.API_URL}/document/acknowledge-errors/${borrowerId}`, {});
  }
}
